import { FC } from 'react';
import { Grid } from '@mui/material';

interface IthHeaderProps {
}

const IthHeader: FC<IthHeaderProps> = ({
  ...rest
}) => {
  return (
    <Grid
      container
      justifyContent="space-between"
      alignItems="center"
      {...rest}
    >
      <Grid item>
        <img alt="SecretariaEstado" id="logoSecretaria" height={80} src="/static/images/logo/Logo_SecretariaTurismo.png" />
      </Grid>
      <Grid item>
        <img alt="ITH" id="logoIth" height={90} src="/static/images/logo/Logo_ITH_pq.png" />
      </Grid>
    </Grid>
  );
};

IthHeader.propTypes = {
};

export default IthHeader;
